import { Injectable } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { Store, select } from '@ngrx/store';
import { selectEntities as selectAppointments } from './+state/appointments/appointments.interfaces';
import { selectEntities as selectWorkOrders } from './+state/work-orders/work-orders.interfaces';
import { selectAll as selectQuotesCombined } from './+state/quotes/quotes.interfaces';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  AppointmentCase,
  ServiceAppointmentDeclinedMpviCode,
  QuoteDetail,
  QuoteHeader,
  Vehicle,
  WorkOrderCase,
  WorkorderDeclinedMpviCode
 } from '@quorum/models/xs-resource';
import * as fromAppointments from './+state/appointments/appointments.actions';
import * as fromWorkOrders from './+state/work-orders/work-orders.actions';
import * as fromQuotes from './+state/quotes/quotes.actions';
// eslint-disable-next-line max-len

// eslint-disable-next-line max-len
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable()
export class FixedOperationsStateService {
  private toastSubject = new Subject<any>();
  constructor(private store: Store<any>) {}

  addToast(toastObject: any) {
    this.toastSubject.next(toastObject);
  }

  listenForToasts() {
    return this.toastSubject;
  }
  selectAppointment(appointmentId: number) {
    return this.store.pipe(
      select(selectAppointments),
      filter((appointments: any) => {
        return !this.isEmpty(appointments) && appointments[appointmentId] != null;
      }),
      map((appointments: any) => {
        return appointments[appointmentId];
      })
    );
  }

  selectWorkOrder(workOrderId: number) {
    return this.store.pipe(
      select(selectWorkOrders),
      filter((workOrders: any) => {
        return !this.isEmpty(workOrders) && workOrders[workOrderId] != null;
      }),
      map((workOrders: any) => {
        return workOrders[workOrderId];
      })
    );
  }

  selectWorkOrders() {
    return this.store.pipe(
      select(selectWorkOrders),
      filter((workOrders: any) => {
        return !this.isEmpty(workOrders);
      }),
      map((workOrders: any) => {
        return workOrders;
      })
    );
  }

  selectQuoteForVehicle(vehicleId: number) {
    return this.store.pipe(
      select(selectQuotesCombined),
      map((quotes: QuoteHeader[]) => {
        let filterQuote: QuoteHeader[] = quotes.filter((quote: QuoteHeader) => {
          return quote.vehicleId == vehicleId;
        });
        if (filterQuote.length == 1) {
          return filterQuote[0];
        } else {
          return null;
        }
      })
    );
  }

  createAppointmentCase(appointmentCase: AppointmentCase) {
    this.store.dispatch(new fromAppointments.PostAppointmentCaseToServer({ case: appointmentCase }));
  }

  createWorkOrderCase(workOrderCase: WorkOrderCase, vehicle: Vehicle) {
    this.store.dispatch(new fromWorkOrders.PostWorkOrderCaseToServer({ case: workOrderCase, vehicle: vehicle }));
  }

  createAppointmentDeclinedService(declinedService: ServiceAppointmentDeclinedMpviCode, rooftopId?: number) {
    this.store.dispatch(
      new fromAppointments.PostAppointmentDeclinedServiceToServer({
        declinedService: declinedService,
        rooftop: rooftopId
      })
    );
  }

  createWorkOrderDeclinedService(declinedService: WorkorderDeclinedMpviCode, rooftopId?: number) {
    this.store.dispatch(
      new fromWorkOrders.PostDeclinedServiceToWorkOrderToServer({
        declinedMpviCode: declinedService,
        rooftop: rooftopId
      })
    );
  }

  createQuoteCase(quoteCase: QuoteDetail, rooftopId?: number) {
    this.store.dispatch(
      new fromQuotes.PostQuoteCaseToServer({
        case: quoteCase
      })
    );
  }

  createQuoteAndCase(quoteHeader: QuoteHeader, quoteCase: QuoteDetail, rooftopId?: number) {
    this.store.dispatch(
      new fromQuotes.PostQuoteAndCaseToServer({
        header: quoteHeader,
        case: quoteCase
      })
    );
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
